import { SsaiAdPodProps } from '@/Components/VideoPlayer/Core/PlayerTypes';
import { PlaybackMeta } from '@skytvnz/sky-app-store/lib/types/models/PlaybackMeta';
import { isoTimeToSeconds, secondsToIsoTime } from './TimeFormat';

export enum SsaiEventType {
  PodStarted = 'ads-pod-started',
  PodEnded = 'ads-pod-ended',
  AdStarted = 'ads-ad-started',
  AdEnded = 'ads-ad-ended',
  AdPause = 'ads-pause',
  AdPlay = 'ads-play',
}

export const getAdTotalDurationBehindTime = (adPods: SsaiAdPodProps[], time: number): number => {
  return adPods.reduce((sum, pod) => {
    return pod.endTime <= time ? sum + pod.duration : sum;
  }, 0);
};

// Update skipIntro and upNext timings, account all ad durations behind the timings
// eslint-disable-next-line import/prefer-default-export
export const updateCuePoints = (
  playbackMeta: PlaybackMeta,
  adPods: SsaiAdPodProps[],
): PlaybackMeta => {
  if (!playbackMeta?.asset || adPods.length === 0) return playbackMeta;

  let finalPlaybackMeta = { ...playbackMeta };

  let skipIntroStartPosition = isoTimeToSeconds(playbackMeta?.asset?.skipIntro?.startPosition);
  let skipIntroEndPosition = isoTimeToSeconds(playbackMeta?.asset?.skipIntro?.endPosition);
  let autoPlayStartPosition = isoTimeToSeconds(playbackMeta?.asset?.upNext?.startPosition);

  if (typeof skipIntroStartPosition === 'number') {
    skipIntroStartPosition += getAdTotalDurationBehindTime(adPods, skipIntroStartPosition);
    finalPlaybackMeta = {
      ...finalPlaybackMeta,
      asset: {
        ...finalPlaybackMeta.asset,
        skipIntro: {
          ...finalPlaybackMeta.asset.skipIntro,
          startPosition: secondsToIsoTime(skipIntroStartPosition),
        },
      },
    };
  }
  if (typeof skipIntroEndPosition === 'number') {
    skipIntroEndPosition += getAdTotalDurationBehindTime(adPods, skipIntroEndPosition);
    finalPlaybackMeta = {
      ...finalPlaybackMeta,
      asset: {
        ...finalPlaybackMeta.asset,
        skipIntro: {
          ...finalPlaybackMeta.asset.skipIntro,
          endPosition: secondsToIsoTime(skipIntroEndPosition),
        },
      },
    };
  }
  if (typeof autoPlayStartPosition === 'number') {
    autoPlayStartPosition += getAdTotalDurationBehindTime(adPods, autoPlayStartPosition);
    finalPlaybackMeta = {
      ...finalPlaybackMeta,
      asset: {
        ...finalPlaybackMeta.asset,
        upNext: {
          ...finalPlaybackMeta.asset.upNext,
          startPosition: secondsToIsoTime(autoPlayStartPosition),
        },
      },
    };
  }

  return finalPlaybackMeta;
};
